<template>
    <v-dialog v-model="dialog" eager max-width="600px">
        <template v-slot:activator="{ on }">
            <slot>
                <v-btn v-if="isNew" class="mt-5" color="primary" @click="openDialog">{{ $t('Добавить') }}</v-btn>
                <v-btn v-else icon v-on="on" text class="grey--text px-0 rounded-btn" :title="$t('Детализация документа')" dense @click="openEdit">
                    <v-icon>mdi-file-eye-outline</v-icon>
                </v-btn>
            </slot>
        </template>
        <LabeledCard :label="isNew ? $t('Добавление нового документа') : $t('Детализация документа')">
            <v-container class="pt-5 px-5" fluid>
                <v-form ref="documentForm">
                    <v-select
                        outlined
                        dense
                        :label="$t('Договор')"
                        :items="CLT"
                        :append-icon="append_icon()"
                        item-text="contract_number"
                        item-value="contract_rid"
                        v-model="contract_rid"
                        :readonly="readonly || !!contractRid"
                        v-if="isNew && (isContract || isEngineer)"
                        :rules="isEngineer ? requiredWhen : [required]"
                    ></v-select>

                    <v-select
                        outlined
                        dense
                        :label="$t('Наименование объекта')"
                        :items="OLT"
                        :append-icon="append_icon()"
                        item-text="object_name"
                        item-value="obj_contract_rid"
                        v-model="obj_contract_rid"
                        :readonly="readonly || !!objContractRid"
                        v-if="!viewOnly && (isContract || isEngineer)"
                        :rules="isEngineer ? requiredWhen : [required]"
                    ></v-select>

                    <v-select
                        outlined
                        dense
                        :label="$t('Адрес дома')"
                        :items="KHLT"
                        :append-icon="append_icon()"
                        item-text="address_full_name"
                        item-value="ksk_house_rid"
                        v-model="ksk_house_rid"
                        :readonly="readonly || !!kskHouseRid"
                        v-if="!viewOnly && (!isContract || isEngineer)"
                        :rules="isEngineer ? requiredWhen : [required]"
                    ></v-select>

                    <v-select
                        outlined
                        dense
                        :label="$t('Наименование документа')"
                        :items="DTLT"
                        :append-icon="append_icon()"
                        item-text="doc_type_name"
                        item-value="ahs_doc_type_rid"
                        v-model="ahs_doc_type_rid"
                        :readonly="readonly"
                        :rules="[required]"
                    ></v-select>

                    <v-textarea maxlength="500" outlined dense auto-grow v-model="comment" :readonly="readonly" :label="$t('Комментарий')"></v-textarea>

                    <template v-if="isNew">
                        <div class="d-flex justify-start align-center mb-2">
                            <v-btn depressed small @click="clickInput" color="info" messages="eswrwer">
                                <v-icon left small>mdi-paperclip</v-icon>
                                <span> {{ $t('Приложить файл') }} </span>
                            </v-btn>
                            <input
                                style="display: none"
                                type="file"
                                ref="file"
                                accept=".jpg, .jpeg, .pdf"
                                name="file"
                                @change="processFile($event)"
                                id="file-input"
                            />
                            <span class="ml-2">{{ fileName }}</span>
                            <span style="color: red" v-if="showFileError">{{ $t('Обязательное поле') }}</span>
                        </div>
                        <div style="color: red; font-size: .9rem; line-height: 1rem">{{ $t('Объем прикрепляемого файла не должен превышать 28 Mb') }}</div>
                        <div style="color: red; font-size: .9rem; line-height: 1rem">{{ $t('Допустимые форматы файлов: jpg, jpeg, pdf') }}</div>
                    </template>
                    <v-row class="mt-2" v-else>
                        <v-col cols="12" class="d-flex justify-space-around">
                            <v-btn color="primary" @click="downloadFile">
                                <v-icon left>mdi-download-outline</v-icon>
                                <span>{{ documentItem.attach_file_name }}</span></v-btn
                            >
                            <!-- <v-btn @click="clickInput" class="ml-1" color="primary">{{ $t('Вложить другой файл') }}</v-btn> -->
                        </v-col>
                    </v-row>
                </v-form>
                <v-row class="mt-2">
                    <v-col cols="12" class="d-flex justify-end">
                        <v-btn outlined color="primary" @click="dialog = false">{{ $t('Закрыть') }}</v-btn>
                        <v-btn depressed class="ml-5" v-if="isNew" color="info" @click="clickSave" :loading="loading">{{ $t('Сохранить') }}</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </LabeledCard>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LabeledCard from '@/components/ui/LabeledCard.vue';
import translate from '@/utils/translate.util';
import BinCheckMixin from '@/mixins/BIN_Checker';
import FormValidator from '@/mixins/FormValidator';
import fileSaver from 'file-saver';
export default {
    name: 'AddEditDocument',
    mixins: [BinCheckMixin, FormValidator],
    props: {
        isNew: { type: Boolean, default: false },
        documentItem: { type: Object },
        document: { type: Object },
        isContract: { type: Boolean },
        isEngineer: { type: Boolean },
        viewOnly: { type: Boolean, default: false },
        kskHouseRid: { type: Number, default: null },
        contractRid: { type: Number, default: null },
        objContractRid: { type: Number, default: null }
    },
    components: { LabeledCard },
    data: () => ({
        dialog: false,
        ahs_doc_type_rid: null,
        comment: null,
        readonly: true,
        contract_rid: null,
        obj_contract_rid: null,
        ksk_house_rid: null,
        loading: false,
        fileName: null,
        attachment_link_rid: null,
        showFileError: false
    }),
    computed: {
        ...mapState('documents', ['DocTypeList', 'ContractList', 'ObjectList', 'KSKHouseList', 'Pagination', 'ContractRid', 'KSKRid', 'file']),
        ...mapState('users', ['userInfo']),
        DTLT() {
            return translate(this.DocTypeList, 'full', this.$i18n.locale);
        },
        CLT() {
            return translate(this.ContractList, 'full', this.$i18n.locale);
        },
        OLT() {
            return translate(this.ObjectList, 'full', this.$i18n.locale);
        },
        KHLT() {
            return translate(this.KSKHouseList, 'full', this.$i18n.locale);
        },
        requiredWhen: function(v) {
            let req = !this.obj_contract_rid && !this.ksk_house_rid;
            let reqr = this.obj_contract_rid && this.ksk_house_rid;
            if (reqr) {
                return [v => !reqr || this.$t('Необходимо выбрать адрес дома или обьект')];
            }
            return [v => !req || this.$t('Обязательное поле')];
        }
    },
    methods: {
        ...mapActions('documents', ['getUserObjectContractsList', 'postDoc', 'attachmentsTempInsert', 'getDocumentList', 'getFile', 'getRefAhsDocTypes']),
        ...mapActions('users', ['getUserInfo']),
        openDialog() {
            this.$refs.documentForm.resetValidation();
            this.dialog = true;
            this.readonly = false;
            this.ahs_doc_type_rid = null;
            this.comment = null;
            this.contract_rid = this.contractRid;
            this.obj_contract_rid = this.objContractRid;
            this.ksk_house_rid = this.kskHouseRid;
            this.resetInput();
            this.fileName = '';
        },
        append_icon() {
            return this.isNew ? 'mdi-menu-down' : '';
        },
        openEdit() {
            this.readonly = true;
            this.ahs_doc_type_rid = this.documentItem.ahs_doc_type_rid;
            this.comment = this.documentItem.comment;
            this.obj_contract_rid = this.documentItem.obj_contract_rid;
            this.ksk_house_rid = this.documentItem.ksk_house_rid;

            if (this.obj_contract_rid) {
                this.$store.commit('documents/setObjectList', [{ obj_contract_rid: this.obj_contract_rid, object_name: this.documentItem.info_name }]);
            }
        },
        async downloadFile() {
            await this.getFile({
                iAhsDocument_rid: this.documentItem.record_id
            }).then(() => {
                const byteOffset = 0;
                const b = new Blob([new Uint8Array(this.file.attach_file.data, byteOffset, length)]);
                const reader = new FileReader();

                reader.readAsDataURL(b);
                reader.onload = () => {
                    fileSaver.saveAs(reader.result, this.documentItem.attach_file_name);
                };
            });
        },
        async clickSave() {
            this.loading = true;
            try {
                this.showFileError = false;
                if (!this.attachment_link_rid) {
                    this.showFileError = true;
                }
                if (!this.$refs.documentForm.validate() || this.showFileError) return;
                await this.getUserInfo();
                let data = {};
                data.ahs_doc_type_rid = this.ahs_doc_type_rid;
                data.record_id = null;
                data.to_delete = 0;
                data.attachment_link_rid = this.attachment_link_rid;
                data.comment = this.comment;
                if (this.obj_contract_rid) data.object_contracts = [{ object_contract_rid: this.obj_contract_rid, to_delete: 0 }];
                if (this.ksk_house_rid) data.ksk_houses = [{ ksk_house_rid: this.ksk_house_rid, to_delete: 0 }];
                data.user_rid = this.userInfo.record_id;
                //console.log(data);
                let res = await this.postDoc({ nvcDocumentsData: data });
                if (res && res.successfull) {
                    let color = 'success';
                    let message = this.$t('Документ успешно добавлен');
                    this.$store.dispatch('base/showMessage', { color, message });
                }
                if (this.document && res && res.successfull) {
                    this.document.ahs_document_rid = res.data.ahs_document[0].record_id;
                }
                if (!this.document) {
                    if (this.isContract) {
                        await this.getDocumentList({
                            ContractRid: this.ContractRid,
                            itemsPerPage: this.Pagination.itemsPerPage,
                            currentItem: this.Pagination.itemsPerPage * (this.Pagination.page - 1)
                        });
                    } else {
                        await this.getDocumentList({
                            KSKRid: this.KSKRid,
                            itemsPerPage: this.Pagination.itemsPerPage,
                            currentItem: this.Pagination.itemsPerPage * (this.Pagination.page - 1)
                        });
                    }
                }
                this.$emit('documentAdded', res.data.ahs_document[0].record_id);
                this.dialog = false;
            } finally {
                this.loading = false;
            }
        },
        clickInput() {
            this.$refs.file.click();
        },

        async processFile(evt) {
            this.attachment_link_rid = null;
            this.$store.commit('documents/setFile', null);
            if ((evt.target.files[0].size < 28000000 && evt.target.files[0].type == 'image/jpeg') || evt.target.files[0].type == 'application/pdf') {
                this.fileName = evt.target.files[0].name;
                let formData = new FormData();
                formData.append('file', evt.target.files[0]);
                let response = await this.attachmentsTempInsert(formData);
                this.attachment_link_rid = response.data.attachment_link_rid;
                this.resetInput();
                this.showFileError = false;
            } else {
                this.fileName = '';
                this.attachment_link_rid = null;
            }
        },
        resetInput() {
            document.getElementById('file-input').value = '';
        }
    },
    watch: {
        async contract_rid() {
            this.getUserObjectContractsList({ ContractRid: this.contract_rid });
        }
    },
    async created() {
        await this.getRefAhsDocTypes();
    }
};
</script>
